import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { environment } from 'src/environments/environment';

export interface EquipmentHistoryRow {
	user_full_name: string;
	user_email: string;
	user_login: string;
	ci_id: number;
	identification: string;
	serial_number: string;
	received_date: string;
	returned_date: string;
	responsibility_signed_date: string;
	devolution_signed_date: string;
	is_with_user: boolean | number;
}

export interface EquipmentHistoryResponse {
	data: EquipmentHistoryRow[];
	total_count: number;
}

@Injectable({
	providedIn: 'root',
})
export class EquipmentHistoryReportService {
	private reportUrl = environment.baseApiUrl + 'reportcmdb/report/equipmentHistoryByUser';

	constructor(
		private http: HttpClient,
		private AuthLoginService: AuthLoginService
	) {}

	private getHeaders(): HttpHeaders {
		return new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
	}

	getHistory(search = '', page = 1, pageSize = 20, recount = true): Observable<EquipmentHistoryResponse> {
		return this.http.get<EquipmentHistoryResponse>(this.reportUrl, {
			headers: this.getHeaders(),
			params: new HttpParams()
				.set('user_search', search.trim())
				.set('offset', (page - 1) * pageSize)
				.set('pagesize', pageSize)
				.set('recount', recount),
		});
	}
}
